import { render, staticRenderFns } from "./ticketChanging.vue?vue&type=template&id=304f8074&scoped=true&"
import script from "./ticketChanging.vue?vue&type=script&lang=js&"
export * from "./ticketChanging.vue?vue&type=script&lang=js&"
import style0 from "./ticketChanging.vue?vue&type=style&index=0&id=304f8074&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f8074",
  null
  
)

export default component.exports